import { DEFAULT_POINTS_PER_EURO, DEFAULT_POINTS_SCALE } from "@/features/sponsorship/constants/bareme";
import type { SponsorshipPointsScale, SponsorshipTerm } from "@/features/sponsorship/types/sponsorship.type";

export type SponsorshipBareme = {
  pointsScale: SponsorshipPointsScale
  pointsPerEuro: number
  totalPointsPerSignedCse: number
  eurPerSignedCse: number
  eurForPoints: (points: number) => number
};

// Source unique du barème affiché côté benef : les valeurs viennent du
// règlement publié servi par l'API (base) ; à défaut, les constantes par
// défaut. Plus aucun nombre de barème n'est codé en dur dans les écrans.
export const deriveBareme = (term: SponsorshipTerm | null): SponsorshipBareme => {
  const pointsScale = term?.points_scale ?? DEFAULT_POINTS_SCALE;
  const pointsPerEuro = term?.points_per_euro ?? DEFAULT_POINTS_PER_EURO;
  const totalPointsPerSignedCse = pointsScale.cse_qualifie + pointsScale.rdv_confirme + pointsScale.signe;

  return {
    pointsScale,
    pointsPerEuro,
    totalPointsPerSignedCse,
    eurPerSignedCse: totalPointsPerSignedCse / pointsPerEuro,
    eurForPoints: (points: number) => points / pointsPerEuro,
  };
};
